import { GET_TEAM_MEMBERS } from 'actions/Types';

export default (state = [], action) => {
  if (action.type === `${GET_TEAM_MEMBERS}_SUCCESS`) {
    return action.payload;
  }

  return state;
};
